export const SUBMIT_EMPLOYEE = "SUBMIT_EMPLOYEE";
export const SUBMIT_EMPLOYEE_SUCCESS = "SUBMIT_EMPLOYEE_SUCCESS";
export const GET_EMPLOYEE_DETAILS = "GET_EMPLOYEE_DETAILS";
export const GET_EMPLOYEE_DETAILS_SUCCESS = "GET_EMPLOYEE_DETAILS_SUCCESS";
export const EDIT_EMPLOYEE = "EDIT_EMPLOYEE";
export const EDIT_EMPLOYEE_SUCCESS = "EDIT_EMPLOYEE_SUCCESS";
export const DELETE_EMPLOYEE = "DELETE_EMPLOYEE";
export const DELETE_EMPLOYEE_SUCCESS = "DELETE_EMPLOYEE_SUCCESS";
